export default "__VITE_ASSET__CYgDjl40__"